import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BoardInfoasyncReqPros, BoardInfoInitialState } from "../model/BoardInfoReducerType";

const reducerId = "BoardInfoReducer/asyncReqBoardInfo";
const controllerMap = new Map();

const initialState: BoardInfoInitialState = {
    status: "",
    n4ErrorCode: 0,
    strErrorMessage: "",
    isSuccess: false,
    INFO: {
        V_LOGIN_MEM_UDID: "",
        V_COMMENT_TOTAL_COUNT: 0,
        UBM_HIT_COUNT: 0,
        V_CAT_CLASS_NM: "",
        V_CAT_NM: "",
        V_FIRST_YN: "",
        UBM_BOARD_SEQ: "",
        UBM_TITLE: "",
        UBM_CONTENT: "",
        UBM_IMG_PATH: "",
        V_PREVIEW_IMG_PATH: "",
        V_IMG_WIDTH: 0,
        V_IMG_HEIGHT: 0,
        V_FILE_SIZE: "",
        UBM_REG_MEM_UDID: "",
        UBM_REG_NICKNAME: "",
        UBM_REG_DT: ""
    }
};

let global_view_type = "";

const slice = createSlice({
    name: "BoardInfoReducer",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(asyncReqBoardInfo.pending, (state) => {
            state.status = "LOADING";
        });
        builder.addCase(asyncReqBoardInfo.fulfilled, (state, action) => {
            state.status = "COMPLETE";
            state.n4ErrorCode = action.payload.n4ErrorCode;
            state.strErrorMessage = action.payload.strErrorMessage;
            state.isSuccess = action.payload.isSuccess;
            if(state.n4ErrorCode === 0 && state.isSuccess) {
                state.INFO = action.payload.INFO;

                // 일부 버튼을 클릭한 경우
                if ([
                    "PREV", // 이전
                    "NEW", // 최신
                    "NEXT" // 다음
                ].includes(global_view_type)) {
                    localStorage.setItem("order_seq_" + state.INFO.V_LOGIN_MEM_UDID, state.INFO.UBM_BOARD_SEQ); // '순차' 버튼 활성화 당시 마지막으로 본 게시물 고유번호 저장하기
                }
            }
        });
        builder.addCase(asyncReqBoardInfo.rejected, (state, action) => {
            if (action.payload?.aborted) return; // 'AbortError'로 인한 취소라면 상태 변경하지 않음
            state.status = "FAIL";
        });
    }
});

type RejectPayload = { aborted: boolean; message?: string };

export const asyncReqBoardInfo = createAsyncThunk<
        any, // 성공 시 반환 타입 (API 응답 타입)
        BoardInfoasyncReqPros, // thunk 파라미터 타입
        {
            rejectValue: RejectPayload; // ❗ rejectWithValue 타입 명시
        }
    >(
    reducerId,
    async ({view_type, board_seq}: BoardInfoasyncReqPros, thunkAPI) => {
        global_view_type = view_type;

        // 이전 요청이 있으면 취소
        const prevController = controllerMap.get(reducerId);
        if (prevController) prevController.abort();

        // 새 요청용 controller 생성
        const controller = new AbortController();
        controllerMap.set(reducerId, controller);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_DOMAIN}/ApiReact/BoardDynamicViewInfo.aspx?view_type=${encodeURIComponent(view_type)}&board_seq=${encodeURIComponent(board_seq)}&board_type=P`,
                {
                    signal: controller.signal,
                }
            );
            const data = await res.json();
            return data;
        }
        catch (error: any) {
            // ❗ AbortError인 경우는 구분해서 처리
            if (error.name === "AbortError") {
                return thunkAPI.rejectWithValue({ aborted: true });
            }
            return thunkAPI.rejectWithValue({ aborted: false, message: error.message });
        }
    }
);

export const BoardInfoActions = slice.actions;
export default slice.reducer;